import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

import { resetCompanyState, getCompany } from "../../store/company/action";
import { resetClientState, getClient } from "../../store/client/action";

//Import actions
import { getNotification as onGetNotifications, addNewNotification as onAddNewNotification, updateNotification as onUpdateNotification, deleteNotification as onDeleteNotification, getNotificationLoading, setReadNotification as onSetReadNotification } from "../../store/notification/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import ExportDoc from "../../Components/Common/ExportDoc";

const Notif = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [pageIdx, setPageIdx] = useState(0);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const dispatch = useDispatch();

  const { clients, clientLoading, companies, companyLoading, notifications, isNotificationCreated, isNotificationSuccess, loading, error } = useSelector((state) => ({
    notifications: state.Notification.notifications,
    isNotificationCreated: state.Notification.isNotificationCreated,
    isNotificationSuccess: state.Notification.isNotificationSuccess,
    loading: state.Notification.loading,
    error: state.Notification.error,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [notificationList, setNotificationList] = useState([]);
  const [notificationDoc, setNotificationDoc] = useState([]);
  const [notification, setNotification] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const typeData = [
    {
      options: [
        { label: "Sales", value: "Sales" },
        { label: "Purchase", value: "Purchase" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const onClickDelete = (notification) => {
    setNotification(notification);
    setDeleteModal(true);
  };

  const handleDeleteNotification = () => {
    if (notification) {
      dispatch(onDeleteNotification(notification));
      setDeleteModal(false);
    }
  };

  // useEffect(() => {
  //   setNotificationList(notifications);
  // }, [notifications]);

  useEffect(() => {
    if (!isEmpty(notifications)) setNotificationList(notifications);
  }, [notifications]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredNotifications = notifications;
      if (type !== "all") {
        filteredNotifications = notifications.filter((notification) => notification.notification_user[0]?.hasRead === type);
      }
      setNotificationList(filteredNotifications);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method && obj?.data?.user?.user_position?.position_role.method);
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`);
        setClientSelect({
          label: obj.data.client_name,
          value: obj.data.clientId,
        });
        setCompanySelect({
          label: obj.data.company_name,
          value: obj.data.companyId,
        });

        dispatch(onGetNotifications());
        dispatch(resetClientState());
        dispatch(getClient());
        handleGetCompany(obj.data.clientId);
      }
    }
  }, [dispatch, isSearch]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  // useEffect(() => {
  //   setNotification(notifications);
  // }, [notifications]);

  // useEffect(() => {
  //   if (!isEmpty(notifications)) {
  //     setNotification(notifications);
  //     setIsEdit(false);
  //   }
  // }, [notifications]);

  useEffect(() => {
    if (!isEmpty(notifications)) {
      setNotificationList(notifications.map((el) => ({ ...el, isChecked: false })));
    }
  }, [notifications]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Tipe",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Hari Pembayaran",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
      {
        id: "payment_term_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "payment_term_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
    ];

    if (notificationList.length > 0) {
      notificationList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "payment_term_client" || doc.id === "payment_term_company") {
                doc.data.push(value?.name ?? "");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setNotificationDoc(dataDoc);
  }, [notificationList]);

  const toggle = useCallback(
    (data = null) => {
      if (modal) {
        notification.hasSend = true;
        const userNotificationId = notification.notification_user?.[0]?.id;
        if (userNotificationId) {
          dispatch(onSetReadNotification({ id: userNotificationId, notifId: notification.id }));
        }
        setModal(false);
        setNotification(null);
      } else {
        setModal(true);
        setNotification(data);
      }
    },
    [modal]
  );

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteNotification(element.value));
    });
    checkall.checked = false;
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);

  // Column
  const columns = useMemo(() => [{
    id: "#",
    Header: "",
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      const isRead = data?.notification_user ? data?.notification_user[0]?.hasRead : false;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={isRead}
            disabled
          // onChange={() => {
          //   const updatedData = notificationList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
          //   setNotificationList(updatedData);
          // }} 
          />
          <ButtonGroup className="me-1">
            <UncontrolledButtonDropdown>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateNotification") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  toggle(data);
                }}>
                <i className="ri-book-open-line fs-15"></i>
              </Button>
              {/* <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteNotification") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}>
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button> */}
            </UncontrolledButtonDropdown>
          </ButtonGroup>
        </div>
      );
    },
  },
  {
    Header: "Title",
    accessor: "name",
    filterable: true,
  },
  {
    Header: "Message",
    accessor: "message",
    filterable: true,
  },
  {
    Header: "Kategori",
    accessor: "category",
    filterable: true,
  },
  {
    Header: "Tanggal",
    accessor: "createdat",
    filterable: true,
    Cell: (data) => {
      return data.row.original.createdat ? handleValidDate(data.row.original.createdat, "D/MM/YYYY") : "";
    },
  },
  ],
    [notificationList, userRole, userType, isCheckAll]
  );


  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = notificationList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setNotificationList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => notificationList, [notificationList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleNotificationStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetNotifications(param));
  }

  document.title = "Payment Terms | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={notificationList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteNotification} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Notifikasi" pageTitle="Notifikasi" />
        <Row>
          <Col lg={12}>
            <Card id="notificationList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Data Notifikasi &nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={"btn btn-success add-btn me-1"}
                      id="create-btn"
                      onClick={() => {
                        dispatch(onSetReadNotification({ id: "all", notifId: "all" }));
                      }}>
                      <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tandai di baca semua
                    </button>
                    {/* <ExportDoc data={notificationDoc} />
                    <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn ms-1 btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteNotification") !== -1 ? "btn ms-1 btn-soft-danger" : "btn ms-1 btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                    </button> */}
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#">
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA NOTIFIKASI
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", true);
                        }}
                        href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> SUDAH DIBACA
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", false);
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> BELUM DIBACA
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={8}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""} />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}>

                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}>

                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {notification?.name}
                  </ModalHeader>
                  <ModalBody>
                    <p>{handleValidDate(notification?.createdat)}</p>
                    <p>{notification?.message}</p>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="button" className="btn btn-light" onClick={toggle}>
                        Tutup
                      </button>
                    </div>
                  </div>
                </Modal>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Notif;
